<template id="dashboardTmpl">
    <ct-main-layout-appgui :backurl="backurl" :breadcrumbs="breadcrumbs" >

		<v-card>
			<!-- TITLE -->
			<v-card-title>{{detailOrg.organization_name}}</v-card-title>

			<v-card-text v-if="sitesList != null && sitesList.length > 0" class="font-weight-bold">
				{{$t('lbl.numSitesFound')}}: {{sitesList.length }} 
			</v-card-text>
			<v-card-text v-else class="font-weight-bold">
				{{$t('err.noSitesFound')}}
			</v-card-text>
			<v-card-text>
				<!-- GOOGLE MAPS -->
				<ct-sites-google-map  ref="sitesGoogleMaps" :orgid="$root.$route.params.orgId" :sitesList="sitesList"></ct-sites-google-map>
			</v-card-text>
			<div v-if="sitesList != null && sitesList != []">
				<v-card-text v-for="item in sitesList" v-bind:key="item.site_id">
					<v-row no-gutters>
						<v-col cols="12">

							<v-tooltip top> 
								<template v-slot:activator="{ on, attrs }">
									<v-btn 
										class="button-secondary mr-2" fab small depressed
										v-bind="attrs"
										v-on="on" 
										@click="setCenterBySite(item)" 
										><v-icon>explore</v-icon></v-btn>
								</template>
								<span>{{ $t('btn.geolocate')}}</span>
							</v-tooltip>					
								
							<v-icon v-if="item.alert" class="alertIcon mr-2">mdi-alert</v-icon>
							<span class="text-capitalize font-weight-bold">{{item.site_name}}</span>
						</v-col>
					</v-row>
					<v-divider></v-divider>			
				</v-card-text>
			</div>	
		</v-card>

    </ct-main-layout-appgui>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

import ctSitesGoogleMap from "@/components/appgui/ctSitesGoogleMap.vue";

export default {
	i18n,
	data: () => ({
		backurl: '/appgui',
		breadcrumbs:[],
		detailOrg: null,
		sitesList: [],
	}),
	components: {
		'ct-sites-google-map': ctSitesGoogleMap
	},
	created(){
		this.detailOrg = this.getEmptyOrgGuiAdmin();
	},
	mounted() {
		//=== BLOCCO LA PAGINA
		this.$root.globalPageLoading = true;

		//=== NAVIGATION BAR
		this.breadcrumbs = [
			{ text: i18n.t('breadcrumb.appgui'), disabled: false, href: '/tools/appgui' }
		]

		//=== STARTUP	
		this.loadOrgDetails();
	},
	methods: {
		loadOrgDetails() 
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			}
			else 
			{
				var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.$route.params.orgId
				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadOrgDetails, 'err.loadingOrg');
			}
		},
		callbackLoadOrgDetails(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.detailOrg = responseData;

				this.breadcrumbs.push({text: this.detailOrg.organization_name, disabled: false});

				this.loadSitesList();
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingOrg"));
			}
		},
		loadSitesList() 
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			}
			else 
			{
				//var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.$route.params.orgId + '/sites';
				
				var endpoint2go = constants.ENDPOINT_GATEWAY_SITES_LIST_ALERT;
				endpoint2go += "?org=" + this.$route.params.orgId;

				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadSitesList, 'err.loadingSites');
			} 
		},
		callbackLoadSitesList(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.sitesList = this.getSecureSiteList(responseData, true);
				
				if (!this.isEmptyObj(this.sitesList) && this.sitesList.length > 0) 
				{
					this.$refs.sitesGoogleMaps.initGoogleMapSites(this.sitesList);
				}

				//=== SBLOCCO LA PAGINA
				this.$root.globalPageLoading = false;
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingSites"));
			}
		},
		setCenterBySite(siteObj)
		{
			if(!this.isEmptyObj(siteObj))
			{
				this.$refs.sitesGoogleMaps.setGoogleCenterBySite(siteObj);
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			} 
		}
	},
}
</script>